import React from "react";
import Box from "@mui/material/Box";
import CircleIcon from "@mui/icons-material/Circle";

export default function CircleIconMatchRatioColor({ ratio }) {
  const colorDiscrimination = (r) => {
    if (!r || r <= 50) return "#E9E9E9";
    if (r <= 60) return "#D2D2D2";
    if (r <= 70) return "#BCBCBC";
    if (r <= 74) return "#D7D2B8";
    if (r <= 75) return "#DDD7B7";
    if (r <= 76) return "#E4DCB6";
    if (r <= 77) return "#EBE2B5";
    if (r <= 78) return "#F1E7B4";
    if (r <= 80) return "#FFF2B2";
    if (r <= 82) return "#FEEDB3";
    if (r <= 83) return "#FEEAB3";
    if (r <= 84) return "#FDE7B3";
    if (r <= 86) return "#FDE2B4";
    if (r <= 87) return "#FDDFB4";
    if (r <= 91) return "#FBD3B5";
    if (r <= 93) return "#FACCB6";
    if (r <= 95) return "#FAC5B6";
    if (r <= 97) return "#F9BEB7";
    return "#F8BAB7"; // 98~100
  };

  const bgcolor = colorDiscrimination(ratio);

  return (
    <Box sx={{ color: bgcolor }}>
      <CircleIcon />
    </Box>
  );
}